import { connect } from 'react-redux'
import UCReasonForVisitModal from './UCReasonForVisitModal.jsx'

const mapStateToProps = (state) => ({
  reasonForVisit: state.scheduling.reasonForVisit, 
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setReasonForVisit: (reason) => dispatch({ type: 'SET_REASON_FOR_VISIT', value: reason }),
  setVideoVisitEligibility: (isEligibleForVideoVisit) => dispatch({ type: 'SET_VIDEO_VISIT_ELIGIBILITY', value: isEligibleForVideoVisit })
})

export default connect(mapStateToProps, mapDispatchToProps)(UCReasonForVisitModal)
